module.exports = __webpack_public_path__ + "img/cards2_front10.32c4c2c2.png";